module.exports = __webpack_public_path__ + "static/media/aqua.b118155d.png";